import merge from 'lodash.merge';

import sharedScreen from '#frontend/singleDataLayer/shared/screen.js';

/**
 * Review page object
 * @param {object} cart Cart data object
 * @returns {object} Single data layer object
 */
export default (cart) => {
	const screen = {
		screen: {
			type: 'checkout',
			section: 'Summary',
			name: 'ReviewPage'
			// productLists: [productList(cart, 'cart.review')]
		}
	};

	return merge(screen, sharedScreen(cart));
};
